import { cn } from "@/lib/utils";
import { qualificationKnown, useDealGates } from "./DealGates";

export type DealSection = "activity" | "qualification" | "products" | "proposals" | "agreements" | "files" | "history";

/** The deal's sections, with a count where it helps */
export function DealTabs({ value, onChange, counts }: { value: DealSection; onChange: (s: DealSection) => void; counts: Partial<Record<DealSection, number | string>> }) {
  const { gates } = useDealGates();
  const known = gates ? Object.values(qualificationKnown(gates.qualification)).filter(Boolean).length : null;
  const all = { ...counts, ...(known !== null ? { qualification: `${known}/4` } : {}) };
  const items: { key: DealSection; label: string }[] = [
    { key: "activity", label: "Activity" },
    { key: "qualification", label: "Qualification" },
    { key: "products", label: "Products & quote" },
    { key: "proposals", label: "Proposals" },
    { key: "agreements", label: "Agreements" },
    { key: "files", label: "Files" },
    { key: "history", label: "History" },
  ];
  return (
    <div role="tablist" aria-label="Deal sections" className="flex gap-0.5 overflow-x-auto border-b border-border px-1.5">
      {items.map((t) => {
        const on = t.key === value;
        const c = all[t.key];
        return (
          <button
            key={t.key}
            type="button"
            role="tab"
            aria-selected={on}
            onClick={() => onChange(t.key)}
            className={cn("h-10 shrink-0 border-b-2 px-3.5 text-[13px]", on ? "border-primary font-semibold text-foreground" : "border-transparent font-medium text-muted-foreground hover:text-foreground")}
          >
            {t.label}
            {c !== undefined && c !== 0 && c !== "" && <span className={cn("ml-1.5 rounded-full px-1.5 font-mono text-[11px]", on ? "bg-accent text-primary" : "bg-muted text-muted-foreground")}>{c}</span>}
          </button>
        );
      })}
    </div>
  );
}
